import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { postData } from "../../services/api";

import logo from "../../assets/images/DIEL_Montazh_logo-sm.png";
import "../Login/Login.scss";

// Страница от еднократния линк в имейла за потвърждение на регистрацията.
const VerifyEmail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  // { status: "loading" | "success" | "error", message }
  const [result, setResult] = useState({ status: "loading", message: "" });
  // Линкът е еднократен - заявката се праща само веднъж.
  const requested = useRef(false);

  useEffect(() => {
    if (requested.current) return;
    requested.current = true;

    if (!token) {
      setResult({ status: "error", message: "Липсва линк за потвърждение!" });
      return;
    }

    postData("/users/verify-email", { token })
      .then((response) =>
        setResult({ status: "success", message: response.data.message })
      )
      .catch((error) =>
        setResult({
          status: "error",
          message:
            error.response?.data?.message ||
            "Възникна грешка при свързване със сървъра!",
        })
      );
  }, [token]);

  return (
    <div id="auth">
      <div className="row h-100">
        <div className="col-lg-5 col-12">
          <div id="auth-left">
            <div className="auth-logo">
              <img src={logo} alt="Logo" srcSet="" />
            </div>
            <h1 className="auth-title">Потвърждение</h1>

            {result.status === "loading" && (
              <p className="auth-subtitle">Потвърждаваме регистрацията ви...</p>
            )}

            {result.status !== "loading" && (
              <>
                <p className={`auth-subtitle mb-4 ${result.status === "success" ? "text-success" : "text-danger"}`}>
                  {result.message}
                </p>
                {result.status === "success" && (
                  <p className="text-gray-600">Вече можете да влезете в платформата.</p>
                )}
                <button
                  type="button"
                  className="btn btn-primary btn-block btn-lg shadow-lg mt-4"
                  onClick={() => navigate("/login")}
                >
                  Към вход
                </button>
              </>
            )}
          </div>
        </div>
        <div className="col-lg-7 d-none d-lg-block">
          <div id="auth-right"></div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
